import { HISTORY_SINGLE_VIEWS } from './constants';

// 历史路由访问兼容 - 简化重定向
export const LEGACY_ROUTES = [
	// 根路径直接重定向到flow首页
	{
		path: '/',
		redirect: '/investors/flow'
	},
	{
		path: '/index',
		redirect: '/investors/flow'
	},

	// 历史模板首页重定向
	{
		path: '/slide',
		redirect: '/investors/slide'
	},
	{
		path: '/slide/index',
		redirect: '/investors/slide'
	},
	{
		path: '/flowX',
		redirect: '/investors/flowX'
	},
	{
		path: '/flowX/index',
		redirect: '/investors/flowX'
	},
	{
		path: '/flow',
		redirect: '/investors/flow'
	},
	{
		path: '/flow/index',
		redirect: '/investors/flow'
	},

	// 历史入口类型重定向
	{
		path: '/sme/:moduleId',
		redirect: to => `/investors/flow/${to.params.moduleId}`
	},
	{
		path: '/mme/:menuId/:moduleId?',
		redirect: to => {
			const { menuId, moduleId } = to.params;
			return `/investors/flow/mme/${menuId}${moduleId ? `/${moduleId}` : ''}`;
		}
	},
	{
		path: '/qme/:moduleId',
		redirect: to => `/investors/flow/qme/${to.params.moduleId}`
	},

	// flowX历史菜单访问兼容
	{
		path: '/flowX/mme/:menuId/:moduleId?',
		redirect: to => {
			const { menuId, moduleId } = to.params;
			return `/investors/flowX/mme/${menuId}${moduleId ? `/${moduleId}` : ''}`;
		}
	},

	// 历史模块链接访问兼容 - 重定向到REBUILD的「组件」路由
	...HISTORY_SINGLE_VIEWS.map(obj => ({
		path: `/${obj.path}`,
		redirect: `/investors/flow/${obj.path}`
	}))
];
